import { Component, For, Show } from "solid-js";
import { A } from "@solidjs/router";
import type { QuotaNotice } from "../../utils/quotaStatus";

const TONE = {
  warning: {
    panel: "border-signal-amber/25 bg-signal-amber-tint",
    heading: "text-signal-amber",
  },
  hard_stop: {
    panel: "border-signal-red/25 bg-signal-red-tint",
    heading: "text-signal-red",
  },
} as const;

/** Shared markup for the tenant- (FLOW-791) and project-level (FLOW-927) quota banners. */
export const QuotaNoticeStrip: Component<{
  notice: QuotaNotice;
  testId: string;
  dismissLabel: string;
  action?: { label: string; href: string };
  onDismiss: () => void;
}> = (props) => {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={props.testId}
      data-level={props.notice.level}
      class={`border-b px-4 py-2 flex items-start gap-3 ${TONE[props.notice.level].panel}`}
    >
      <div class="flex-1 min-w-0">
        <p class={`text-sm font-semibold ${TONE[props.notice.level].heading}`}>
          {props.notice.title}
        </p>
        <p class="text-xs text-ink-2">{props.notice.body}</p>
        <Show when={props.notice.figures.length > 0}>
          <ul class="mt-1 font-mono text-xs text-ink-2">
            <For each={props.notice.figures}>{(line) => <li>{line}</li>}</For>
          </ul>
        </Show>
      </div>
      <Show when={props.action}>
        {(a) => (
          <A
            href={a().href}
            class={`shrink-0 text-sm font-medium underline hover:no-underline rounded-sm focus-ring ${TONE[props.notice.level].heading}`}
          >
            {a().label}
          </A>
        )}
      </Show>
      <button
        type="button"
        class="shrink-0 p-1 text-ink-3 hover:text-ink rounded-sm transition-colors focus-ring"
        aria-label={props.dismissLabel}
        onClick={() => props.onDismiss()}
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
};
